(() => {
  const init = (root) => {
    if (!root) return;

    const bar = root.querySelector('.nia-ref__trust-row');
    if (bar && root.dataset.luminaBarReady !== 'true') {
      root.dataset.luminaBarReady = 'true';
      let dragging = false;
      let startX = 0;
      let startScroll = 0;

      bar.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        startScroll = bar.scrollLeft;
        bar.classList.add('is-dragging');
        bar.setPointerCapture(event.pointerId);
      });

      bar.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        bar.scrollLeft = startScroll - (event.clientX - startX);
      });

      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        bar.classList.remove('is-dragging');
        if (bar.hasPointerCapture(event.pointerId)) bar.releasePointerCapture(event.pointerId);
      };

      bar.addEventListener('pointerup', stopDragging);
      bar.addEventListener('pointercancel', stopDragging);
    }

    if (root.dataset.luminaStickyReady === 'true') return;
    const sticky = root.querySelector('.nia-ad__sticky');
    const trigger = root.querySelector('.nia-ref__hero-button, .nia-ad__hero .nia-ad__button');
    const offer = root.querySelector('#lumina-offer');
    if (!sticky || !trigger || !offer) return;

    root.dataset.luminaStickyReady = 'true';

    const initJudgeMe = () => {
      if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets();
    };
    initJudgeMe();
    setTimeout(initJudgeMe, 600);

    const update = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const triggerRect = trigger.getBoundingClientRect();
      const offerRect = offer.getBoundingClientRect();
      const passedHeroCta = triggerRect.bottom < 0;
      const offerVisible = offerRect.top < window.innerHeight && offerRect.bottom > 0;
      sticky.classList.toggle('is-visible', mobile && passedHeroCta && !offerVisible);
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    sticky.addEventListener('click', () => requestAnimationFrame(update));
    update();
    setTimeout(update, 250);
  };

  const initAll = () => document.querySelectorAll('[data-lumina-advertorial]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();